let envConfig = {
  token: '',
};

export const setConfig = (config: typeof envConfig) => {
  envConfig = { ...envConfig, ...config };
};

export const getConfig = () => envConfig;
